import styled from '@emotion/styled';

export type TextSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type TextWeight = 'bold' | 'semibold' | 'default' | 'light';
export type TextColor =
  | 'default'
  | 'gray'
  | 'success'
  | 'warning'
  | 'info'
  | 'error';
export type TextAs = 'p' | 'span' | 'label' | 'h2' | 'h3';

type StyledTextProps = {
  $size: TextSize;
  $weight: TextWeight;
  $color: TextColor;
};

const FONT_SIZE: Record<TextSize, string> = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
};

const LINE_HEIGHT: Record<TextSize, string> = {
  xs: '18px',
  sm: '21px',
  md: '24px',
  lg: '27px',
  xl: '28px',
};

const FONT_WEIGHT: Record<TextWeight, number> = {
  light: 300,
  default: 400,
  semibold: 600,
  bold: 700,
};

export const StyledText = styled.p<StyledTextProps>`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: ${({ $size }) => FONT_SIZE[$size]};
  line-height: ${({ $size }) => LINE_HEIGHT[$size]};
  font-weight: ${({ $weight }) => FONT_WEIGHT[$weight]};
  color: ${({ theme, $color }) => {
    switch ($color) {
      case 'gray':
        return theme.palette?.brand.gray[600];
      case 'success':
        return theme.palette?.brand.success[500];
      case 'warning':
        return theme.palette?.brand.attention[500];
      case 'info':
        return theme.palette?.brand.info[300];
      case 'error':
        return theme.palette?.brand.error[500];
      default:
        return theme.palette?.brand.secondary.base;
    }
  }};
`;
